import React, {Component} from 'react';
import './EInvoice.css';
import {Col} from "reactstrap";
import ReactLoading from "react-loading";

class YearPicker extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isMobile : window.innerWidth > 991 ? false : true,
			isScrolled : false
		}
		this.createFullDate = this.createFullDate.bind(this);
		this.createNonMonthDate = this.createNonMonthDate.bind(this);
	}

	getClass(yearValue) {
		return ((this.props.selectedYear === yearValue) ? "active-year " : "") + "year-button"
	}

	getActiveYearClass(yearValue) {
		return ((this.props.selectedYear === yearValue) ? "active-year-div" : "")
	}

	getMonthClass(monthValue) {
		return ((this.props.selectedMonth === monthValue) ? 'active-month ' : '') + 'month-button'
	}

	getReceivedDateListClass(value) {
		return ((this.props.selectedMonth === value) ? 'active-month ' : '') + 'month-button received-date'
	}

	handleMonth(month){
		this.props.onSetMonth(month);
	}

	isActiveLoading(month){
		let self = this;
		let loading = self.props.loading;
		let activeMonth = this.props.selectedMonth;
		return loading && (month === activeMonth);
	}
	handleRecivedDate(){
		let year ={label:"",value:9999}
		this.props.onSetYear(year);
		this.props.onSetMonth(12);

	}

	createFullDate(){
		let {checkMonthBased} = this.props;
		const date = new Date();
		const months = [[0, 'Ocak'], [1, 'Şubat'], [2, 'Mart'], [3, 'Nisan'], [4, 'Mayıs'], [5, 'Haziran'],
			[6, 'Temmuz'], [7, 'Ağustos'], [8, 'Eylül'], [9, 'Ekim'], [10, 'Kasım'], [11, 'Aralık'],[12, (!(this.props.profileId ==="MuhasebeDefterBilgi") && checkMonthBased ? `Son ${checkMonthBased} Ay` : 'Tümü')]];
		const {isMobile,isScrolled} = this.state;
		return(
			<div className="toolBar" style={{marginBottom: '20px'}}>
				{
					isMobile &&
					<p style={{fontWeight:'bold',letterSpacing:'1px',color:'#78b1d7'}} className="text-center mt-2 mb-0">YILLARA GÖRE LİSTELEME</p>
				}
				<div className="btn-group yearPickerContainer" role="group" aria-label="Yıllar"
					 style={{padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', background: 'linear-gradient(45deg, #dedede, transparent)'}}>

					<div
						className="yearButtonsContainer"
						style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: '10px'}}
						onScroll={()=>this.setState({isScrolled : true})}
					>
						{this.props.years.map((year, i) =>
							<div className={this.getActiveYearClass(year.value)}>
								<button key={i} onClick={e => {
									this.props.onSetYear(year)
								}}
										type="button"
										className={this.getClass(year.value)}>
									{year.label}
								</button>
							</div>
						)}
						{!this.props.hideReceivedDate &&
						<div className="">
							<button id="listByReceiveDate" className={this.getClass(9999)} onClick={()=>this.handleRecivedDate()}>
								Alınma Tarihine Göre Listele
							</button>
						</div>
						}
					</div>
					{
						!isScrolled && isMobile &&
						<div className="yearPickerTooltip pt-2 pb-2">
							<i style={{fontSize:'1.3rem',color:'grey'}} className="fas fa-hand-pointer"/>
						</div>
					}
					{
						this.props.selectedYear !== 9999 &&

						<Col sm='12' className='months-row'>
							{this.props.selectedYear !== date.getFullYear() ?
								<div className='month-buttons-div' style={{
									width: 'fit-content',
									display: 'flex',
									flexDirection: 'row',
									flexWrap: 'wrap',
									alignItems: 'center'
								}}>
									{months.map((month, i) =>
										<button key={i}
												onClick={e => {
													this.handleMonth(month[0])
												}}
												className={this.getMonthClass(month[0])}>
											<div className="row" style={{margin: "0", position: "relative"}}>
												{this.isActiveLoading(month[0]) &&
												<ReactLoading type="spinningBubbles" style={{
													width: "18px",
													height: "5px",
													margin: "0",
													fill: "#fff",
													position: "absolute",
													left: "30%",

												}}/>}
												{this.isActiveLoading(month[0]) ?
													<span style={{color: "#78b1d7"}}>{month[1]}</span>
													:
													<span>{month[1]}</span>
												}
											</div>

										</button>
									)}
								</div>

								:

								<div className='month-buttons-div' style={{
									width: 'fit-content',
									display: 'flex',
									flexDirection: 'row',
									flexWrap: 'wrap',
									alignItems: 'center',
								}}>
									{months.map((month, i) => {
											if ((month[0] <= date.getMonth()) || month[0] === 12) {
												return (
													<button key={i}
															onClick={e => {
																this.props.onSetMonth(month[0])
															}}
															className={this.getMonthClass(month[0])}>
														<div className="row" style={{margin: "0", position: "relative"}}>
															{this.isActiveLoading(month[0]) &&
															<ReactLoading type="spinningBubbles" style={{
																width: "18px",
																height: "5px",
																margin: "0",
																fill: "#fff",
																position: "absolute",
																left: "30%",

															}}/>}
															{this.isActiveLoading(month[0]) ?
																<span style={{color: "#78b1d7"}}>{month[1]}</span>
																:
																<span>{month[1]}</span>
															}
														</div>
													</button>
												)
											}
										}
									)}
								</div>
							}
						</Col>
					}

				</div>
			</div>
		)
	}

	createNonMonthDate(){
		const {selectedYearLabel} = this.props;
		const {isMobile,isScrolled} = this.state;
		return(
			<div className="toolBar" style={{marginBottom: '20px'}}>
				<h4 className="col-sm-12 yearPickerHeader"
					style={{marginTop: '5px'}}>{'Yıllara Göre Listeleme - ' + selectedYearLabel}</h4>

				<div
					className={!isMobile ? "btn-group" : "d-flex yearButtonsContainer"}
					role="group"
					aria-label="Yıllar"
					style={{marginBottom: '10px', marginLeft: '10px'}}
					onScroll={()=>this.setState({isScrolled : true})}
				>
					{this.props.years.map((year, i) =>
						<button key={i} onClick={e => {
							this.props.onSetYear(year)
						}}
								type="button"
								className={this.getClass(year.value)}>
							{year.label}
						</button>
					)}

				</div>
				{
					!isScrolled && isMobile &&
					<div className="yearPickerTooltip pt-2 pb-2 mb-2">
						<i style={{fontSize:'1.3rem',color:'grey'}} className="fas fa-hand-pointer"/>
					</div>
				}
			</div>
		)
	}

	renderComponent(){
		let self = this;
		let type = self.props.type;
		if(type === "fulldate"){
			return self.createFullDate();
		}
		else {
			return self.createNonMonthDate();
		}
	}

	render() {
		return (this.renderComponent())
	}
}
export default YearPicker;